import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, onMounted, ref } from 'vue'
import { listByParamCodes } from '@/api/common'
import { potentialList } from '@/api/overseasSales/customerCenter'

import { CustomerCode } from '@/typings/api/customerCenter'
const __default__ = { name: 'list' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: CustomerCode) => void }>()

const tableRef = ref()
const queryForm = reactive({
  name: ''
})

onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_grade', 'zbu_partner_nature', 'zbu_main_customers', 'zbu_campaign_type', 'zbu_partner_role']
  }).then((res) => {
    if (res.code === 200) {
      console.log(11)
    }
  })
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  potentialList(params).then((res) => {
    callBack(res)
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = ref([
  { title: '客户名称', dataIndex: 'noset' },
  { title: '关联客户代码', dataIndex: 'noset' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: CustomerCode) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      tableRef.value?.delFetch()
      console.log(1)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_a_breadcrumb, { separator: ">" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode("运营管理")
            ]),
            _: 1
          }),
          _createVNode(_component_a_breadcrumb_item, null, {
            default: _withCtx(() => [
              _createTextVNode("区号信息")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosAreaCodeInformation"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.name) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "name",
                    label: "客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.name,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.name) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (deleteRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            button: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})